import PropTypes from 'prop-types';
import cx from 'classnames';

import * as style from './text.module.scss';

const Text = ({ as: As = 'p', className, size = 'normal', ...props }) => {
  return <As className={cx(style[size], className)} {...props} />;
};

Text.propTypes = {
  as: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(['micro', 'small', 'normal']),
};

export default Text;
